import { App } from "./App";
import React from "react";
import ReactDOM from "react-dom/client";
import './utils/sentry';

// Had to remove strict mode to make quill work correctly

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
